import { render } from "./category-color-bar.vue?vue&type=template&id=7255a86f&scoped=true&ts=true"
import script from "./category-color-bar.vue?vue&type=script&lang=ts"
export * from "./category-color-bar.vue?vue&type=script&lang=ts"

import "./category-color-bar.vue?vue&type=style&index=0&id=7255a86f&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7255a86f"]])

export default __exports__